import "../../Create/Create.css"
import {Selection} from "./component/Selection";
import {useEffect, useState} from "react";
import {ChatSection} from "./component/ChatSection";
import {Context} from "./component/Context";
import {AiTextEditor} from "./component/AiTextEditor";
import {AboutPre, partition, selectValPartition} from "../component/AboutPre";
import {useLocation} from "react-router-dom";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";

export default function PrePrompt() {
    const {state} = useLocation()

    const [questions, setQuestions] = useState(q);
    const [chattingData, setChattingData] = useState([])
    const [startVal,setStartVal] = useState(false);

    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        const {data} = await axios.get(`${restUrl}/activity_test_application?id=eq.${state.appId}`)
        console.log(data)
        const res = data[0].preview_response.split(partition)
        console.log(res)
        if (res.length === 0) return
        let i = 0
        const qu = q.map(step=>step.map(it=>{
            it.selectVal = res[i].split(selectValPartition)
            i++
            return it
        }))
        setQuestions(qu)
    }

    useEffect(() => {
        console.log(questions)
    }, [questions]);

    return (
        <Context.Provider value={{setQuestions, questions, chattingData, setChattingData, startVal, state}}>
            <AboutPre testId={state.testId}/>
            <Selection/>
            <div className={`${startVal ? "block" : "hidden"}`}>
                <ChatSection/>
                <AiTextEditor/>
            </div>
            <button onClick={()=>setStartVal(true)}
                className={`py-4 px-5 text-center bg-blue-800 text-white`}>시작하기
            </button>
        </Context.Provider>
    )
}

const q = [
    [
        {
            "problem": "",
            "type": "prompt",
            "selections": null,
            "difficulty_id": 0,
            "category": "프롬프트",
            "selectVal": []
        }
    ],
    [
        {
            "problem": "이 시험의 종류",
            "type": "radio",
            "selections": ["프롬프트", "단답형", "번역"],
            "difficulty_id": 1,
            "category": "프롬프트",
            "selectVal": []
        },
        {
            "problem": "이 시험의 목적",
            "type": "check",
            "selections": ["검증", "학습", "증명"],
            "difficulty_id": 1,
            "category": "프롬프트",
            "selectVal": []
        }
    ], [
        {
            "problem": "본인의 이름",
            "type": "shortTB",
            "selections": null,
            "difficulty_id": 2,
            "category": "프롬프트",
            "selectVal": []
        },
        {
            "problem": "본인의 연락처",
            "type": "shortTB",
            "selections": null,
            "difficulty_id": 2,
            "category": "프롬프트",
            "selectVal": []
        },
    ], [

        {
            "problem": "사전 프롬프트",
            "type": "longTB",
            "selections": null,
            "difficulty_id": 3,
            "category": "프롬프트",
            "selectVal": []
        },
    ]
]